
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/discovercalls/[campaignId]",
      function () {
        return require("private-next-pages/discovercalls/[campaignId].tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/discovercalls/[campaignId]"])
      });
    }
  